import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Spinner from '../../components/generics/Spinner';
import _ from 'lodash';
import queryString from 'query-string';

import ReactPaginate from 'react-paginate';

import Filter from '../../components/generics/Filter';
import ReportHeader from '../../components/generics/ReportHeader';
import ReportYield from '../../components/reports/ReportYield';
import FilterYieldModal from '../../components/reports/FilterYieldModal';

import NoPermissionMessage from '../../components/generics/NoPermissionMessage';

import { fetchStations, fetchStationsSuccess, fetchStationsFailure } from "../../store/sessions/actions";
import {
  fetchYieldReport,
  fetchYieldReportSuccess,
  fetchYieldReportFailure,
  fetchYieldReportCSV,
  fetchYieldReportCSVSuccess,
  fetchYieldReportCSVFailure,
  fetchAverageYield,
  fetchAverageYieldSuccess,
  fetchAverageYieldFailure,
} from "../../store/reports/actions";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class ReportYieldContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);
    this.state = {
      page: 1,
      filterFrom: moment().subtract(1, 'week').format('YYYY-MM-DD'),
      filterTo: moment().format('YYYY-MM-DD'),
      searchIngredient: '',
      selectedStationIndex: undefined,
      selectedStation: undefined,
      filterModal:{
        isOpen: false,
        selectedItem: {},
        fromDate: moment().subtract(1, 'week').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
      }
    };

    this.changeSearch = _.debounce(() => {
      this.searchRefresh()
      this.updateQueryString();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const butcherId = '1'
    const params = queryString.parse(this.props.location.search);
    const filterFrom = params.from ? params.from : this.state.filterFrom;
    const filterTo = params.to ? params.to : this.state.filterTo;
    const searchIngredient = params.search ? params.search : undefined;
    const selectedStation = params.selectedStation ? params.selectedStation : (params.selectedStationIndex === '-1' ? undefined : butcherId);
    const selectedStationIndex = params.selectedStationIndex ? params.selectedStationIndex : undefined;
    const page = params.page ? params.page : STARTING_PAGE;

    // Fetch initial page
    this.setState({ page, filterFrom, filterTo, searchIngredient, selectedStation, selectedStationIndex }, () => {
      this.searchRefresh();
    });
    this.props.fetchStations();
  }

  // ---------------------------------------------------------------------------
  // Filters handling
  // ---------------------------------------------------------------------------

  onFromDateChange = (event) => {
    let filterFrom = event.target.value ? event.target.value : this.state.filterFrom;
    this.setState({ filterFrom, page: STARTING_PAGE }, () => {
        this.updateQueryString();
        this.searchRefresh();
    });
  };

  onToDateChange = (event) => {
    let filterTo = event.target.value ? event.target.value : this.state.filterTo;
    this.setState({ filterTo, page: STARTING_PAGE }, () => {
        this.updateQueryString();
        this.searchRefresh();
    });
  };

  onSearchChange = (event) => {
    let searchIngredient = event.target.value ? event.target.value : '';
    this.setState({ searchIngredient, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  onStationChange = (event) => {
    let selectedStationIndex = event.target.value ? (event.target.value).toString() : undefined,
        selectedStation = selectedStationIndex && selectedStationIndex !== '-1' ? this.props.stations[selectedStationIndex].id.toString() : undefined;
    this.setState({ selectedStationIndex, selectedStation, page:1 }, () => {
        this.changeSearch();
    });
  };

  searchRefresh = () => {
    const { page, searchIngredient, filterFrom, filterTo, selectedStation } = this.state;
    this.props.getFilteredYieldReport(page, searchIngredient, filterFrom, filterTo, selectedStation);
    this.props.fetchYieldReportCSV(searchIngredient, filterFrom, filterTo, selectedStation);
  };

  updateQueryString = () => {
    const { filterFrom, filterTo, searchIngredient, page, selectedStation, selectedStationIndex } = this.state;
    let params = {};
    if (filterFrom) params.from = filterFrom;
    if (filterTo) params.to = filterTo;
    if (searchIngredient) params.search = searchIngredient;
    if (selectedStation) params.selectedStation = selectedStation;
    if (selectedStationIndex) params.selectedStationIndex = selectedStationIndex;
    params.page = page;
    this.props.history.push({ search: queryString.stringify(params) });
  };

  // ---------------------------------------------------------------------------
  // Filter modal
  // ---------------------------------------------------------------------------
  openFilterModal = (index) => {
    let reportItem = this.props.yieldReport.report[index]
    this.props.fetchAverageYield(
      reportItem.session, this.state.filterModal.fromDate, this.state.filterModal.toDate)
    this.setState((prevState)=>({
      filterModal:{
        ...prevState.filterModal,
        selectedItem: reportItem,
        isOpen:true,
      }
    }))
  };

  closeFilterModal = () => {
    this.setState({
      filterModal:{
        selectedItem: {},
        isOpen:false,
        fromDate: moment().subtract(1, 'week').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
      }
    })
  };

  handleModalFromChange = (event) => {
    let newValue = event.target.value;
    this.props.fetchAverageYield(
      this.state.filterModal.selectedItem.session, newValue, this.state.filterModal.toDate)
    this.setState((prevState)=>({
      filterModal:{
        ...prevState.filterModal,
        fromDate: newValue,
      }
    }))
  };

  handleModalToChange = (event) => {
    let newValue = event.target.value;
    this.props.fetchAverageYield(
      this.state.filterModal.selectedItem.session, this.state.filterModal.fromDate, newValue)
    this.setState((prevState)=>({
      filterModal:{
        ...prevState.filterModal,
        toDate: newValue,
      }
    }))
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.updateQueryString();
          this.searchRefresh();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    if (!this.state.filterFrom || !this.state.filterTo){
      return <Spinner />;
    } else {
      return (
        <div>
          <div className="card mb-2">
            <ReportHeader title='Yield Report'
                          actionTitle='Export CSV'
                          actionClass='btn btn-primary m-0'
                          headers={['Session', 'Ingredients', 'Station', 'Date', 'TotalYield', 'MainProductYield', 'Tolerance', 'AverageYield']}
                          csvData={this.props.yieldReportCSV.yieldCSV}
                          csvLoading={this.props.yieldReportCSV.loading}
                          filename={`${moment(this.state.filterFrom).format('MMM DD')}-${moment(this.state.filterTo).format('MMM DD')}.csv`}/>
            <Filter
              searchLabel="Search"
              searchPlaceholder="Ingredients.."
              searchVal={this.state.searchIngredient}
              onSearchChange={this.onSearchChange}
              dateLabel="From Date"
              dateVal={this.state.filterFrom}
              onDateChange={this.onFromDateChange}
              dateLabel2="To Date"
              dateVal2={this.state.filterTo}
              onDateChange2={this.onToDateChange}
              dropdownLabel="Station"
              dropdownPlaceholder="Station"
              dropdownVal={this.state.selectedStation}
              onDropdownChange={this.onStationChange}
              dropdownOptions={this.props.stations}
              colClass="col-12 col-sm-3"
            />
          </div>
          <ReportYield
            yieldReportEntries={this.props.yieldReport.report}
            openFilterModal={this.openFilterModal}/>
          {this.props.yieldReport.pages > 1 &&
            <ReactPaginate pageCount={this.props.yieldReport.pages}
                            pageRangeDisplayed={2}
                            marginPagesDisplayed={1}
                            previousLabel="<"
                            nextLabel=">"
                            onPageChange={this.handlePageRequest}
                            initialPage={this.state.page-1}
                            disableInitialCallback={true}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            activeClassName="page-item active"
                            previousClassName="paginate_button previous"
                            nextClassName="paginate_button next"
                            disabledClassName="page-item disabled"
                            forcePage={this.state.page-1}/>
          }
          {this.props.yieldReport.loading ? <Spinner /> : null }
          <FilterYieldModal
            isOpen={this.state.filterModal.isOpen}
            closeModal={this.closeFilterModal}
            onFromDateChange={this.handleModalFromChange}
            onToDateChange={this.handleModalToChange}
            fromDate={this.state.filterModal.fromDate}
            toDate={this.state.filterModal.toDate}
            avgYield={this.props.avgYield}
            item={this.state.filterModal.selectedItem}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    yieldReport: state.reports.yieldReport,
    yieldReportCSV: state.reports.yieldReportCSV,
    avgYield: state.reports.avgYield,
    stations: state.sessions.stationsList.stations.results,
    currentUser: state.auth.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFilteredYieldReport: (page, search='', from, to, category=undefined) => {
      dispatch(fetchYieldReport(page, search, from, to, category)).payload.then((response) => {
        dispatch(fetchYieldReportSuccess(response.data));
      }, (error) => {
        dispatch(fetchYieldReportFailure(error));
      });
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    },
    fetchYieldReportCSV: (search='', from, to, category=undefined) => {
      dispatch(fetchYieldReportCSV(search, from, to, category)).payload.then((response) => {
        dispatch(fetchYieldReportCSVSuccess(response.data));
      }, (error) => {
        dispatch(fetchYieldReportCSVFailure(error));
      });
    },
    fetchAverageYield: (id, from, to) => {
      dispatch(fetchAverageYield(id, from, to)).payload.then((response) => {
        dispatch(fetchAverageYieldSuccess(response.data));
      }, (error) => {
        dispatch(fetchAverageYieldFailure(error));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportYieldContainer));
